/* eslint-disable import/prefer-default-export */
export const UPDATE_ALL_USERS = 'UPDATE_ALL_USERS';
export const UPDATE_ALL_USER_LOGIN_DETAILS = 'UPDATE_ALL_USER_LOGIN_DETAILS';
export const UPDATE_SINGLE_USER_DETAILS = 'UPDATE_SINGLE_USER_DETAILS';
export const UPDATE_SINGLE_USER_SUBSCRIPTIONS = 'UPDATE_SINGLE_USER_SUBSCRIPTIONS';
export const UPDATE_SINGLE_USER_EARNINGS = 'UPDATE_SINGLE_USER_EARNINGS';
export const UPDATE_USERS_ACTIVE_PRODUCTS = 'UPDATE_USERS_ACTIVE_PRODUCTS';
export const UPDATE_USERS_INACTIVE_PRODUCTS = 'UPDATE_USERS_INACTIVE_PRODUCTS';
